// SendEmailActionHeader.jsx

import React from 'react';

// Utilities
import { EMAIL_RECIPIENT_SOURCE_OPTIONS } from '../utils/automationActionEditorUtils';

// CSS
import './SendEmailActionHeader.css';

// Components
import Button from 'components/button/Button';
import SelectInput from 'components/selectinput/SelectInput';

/**
 * SendEmailActionHeader
 *
 * Renders action type, recipient source selector, and remove button.
 *
 * @param {object} theme - Theme object used for dynamic styling.
 * @param {boolean} canRemove - Whether the action remove control is enabled.
 * @param {boolean} [allowEmailActions=true] - Whether send-email actions can be selected.
 * @param {string} recipientSourceType - Active recipient source type.
 * @param {function} onActionTypeChange - Called when the action type selector changes.
 * @param {function} onRecipientSourceTypeChange - Called when recipient source changes.
 * @param {function} onRemove - Called when the row remove button is clicked.
 *
 * @returns {ReactNode} The rendered send-email action header.
 */
const SendEmailActionHeader = React.memo(({
  theme,
  canRemove,
  allowEmailActions = true,
  recipientSourceType,
  onActionTypeChange,
  onRecipientSourceTypeChange,
  onRemove,
}) => {

  const actionTypeOptions = [
    { value: 'set_field', label: 'Update field' },
    ...(allowEmailActions ? [{ value: 'send_email', label: 'Send email' }] : []),
  ];

  // ----- RENDER ----- //

  return (
    <div className="send-email-action-header-container">

      {/* ACTION TYPE */}
      <SelectInput
        style={{ fontSize: '12px' }}
        value="send_email"
        options={actionTypeOptions}
        onChange={(event) => onActionTypeChange(event.target.value)}
      />

      {/* RECIPIENT SOURCE */}
      <SelectInput
        style={{ fontSize: '12px' }}
        value={recipientSourceType}
        options={EMAIL_RECIPIENT_SOURCE_OPTIONS}
        onChange={(event) => {
          const nextType = String(event.target.value || '').trim();
          onRecipientSourceTypeChange(nextType);
        }}
      />

      {/* REMOVE */}
      <div className="send-email-action-header-tail">
        <Button
          iconKey="do_not_disturb_on"
          iconSize="16"
          foregroundColor={theme.foregroundMuted}
          backgroundColor="transparent"
          borderColor="transparent"
          hoverBackgroundColor="transparent"
          borderRadius="6px"
          height="28px"
          width="28px"
          padding="0"
          enabled={canRemove}
          title="Remove action"
          onClick={onRemove}
        />
      </div>

    </div>
  );
});

// Dev Tools
SendEmailActionHeader.displayName = 'SendEmailActionHeader';

export default SendEmailActionHeader;
